function _normalizeSemverString (version) { // @arg String - "Major.Minor.Patch"
    // @ret SemverString - "Major.Minor.Patch"
    const ary = version.split(/[._]/) // "1_2_3" -> ["1", "2", "3"]
                                      // "1.2.3" -> ["1", "2", "3"]
    return ( parseInt(ary[0], 10) || 0 ) + "." +
        ( parseInt(ary[1], 10) || 0 ) + "." +
        ( parseInt(ary[2], 10) || 0 )
}

function _getVersion (ua, token) { // @ret SemverString - "0.0.0"
    try {
        return _normalizeSemverString( ua.split(token)[1].trim().split(/[^\w.]/)[0] )
    } catch ( err ) {
        // ignore
    }
    return '0.0.0'
}

function _detectOS(ua) {
    if (/Android/.test(ua)) {
        return 'Android'
    } else if (/iPhone|iPad|iPod/.test(ua)){
        return 'iOS'
    } else if (/Windows Phone/.test(ua)){
        return 'Windows Mobile'
    } else if (/Windows/.test(ua)){
        return 'Windows'
    } else if (/iemobile/.test(ua)){
        return 'Windows Mobile'
    } else if (/Mac OS X/.test(ua)){
        return 'Mac'
    } else if (/CrOS/.test(ua)){
        return 'Chrome OS'
    } else if (/Firefox/.test(ua)){
        return 'Firefox OS'
    } else {
        return ''
    }
}

function _detectBrowser (ua) {
    switch (true) {
        case /CriOS/.test(ua):
            return 'Chrome for iOS'
        case /Edge/.test(ua):
            return 'Edge'
        case /Chrome/.test(ua):
            return 'Chrome'
        case /Firefox/.test(ua):
            return 'Firefox'
        case /Android/.test(ua):
            return 'AOSP'
        case /MSIE|Trident/.test(ua):
            return 'IE'
        case /Safari\//.test(ua):
            return 'Safari'
        case /AppleWebKit/.test(ua):
            return 'WebKit'
    }
    return ''
}

function _detectBrowserVersion (ua, browser) {
    switch (browser) {
        case 'Chrome for iOS':
            return _getVersion(ua, 'CriOS/')
        case 'Edge':
            return _getVersion(ua, 'Edge/')
        case 'Chrome':
            return _getVersion(ua, 'Chrome/')
        case 'Firefox':
            return _getVersion(ua, 'Firefox/')
        case 'AOSP':
            return _getVersion(ua, /Silk/.test(ua) ? 'Silk/' : 'Version/')
        case 'IE':
            return /IEMobile/.test(ua) ? _getVersion(ua, 'IEMobile/') : (/MSIE/.test(ua)
                ? _getVersion(ua, 'MSIE ') : '')
        case 'Safari':
            return _getVersion(ua, 'Version/')
        case 'WebKit':
            return _getVersion(ua, 'WebKit/')
    }
    return '0.0.0'
}

function _detectIOSVersion (ua) {
    return parseFloat(
        ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(ua) || [0,''])[1])
            .replace('undefined', '3_2').replace('_', '.')
            .replace('_', '')
    ) || false
}

function _isWebView (ua, os, browser, version) { // @ret Boolean - is WebView
    switch (os + browser) {
        case 'iOSSafari':
            return false
        case 'iOSWebKit':
            return _isWebView_iOS()
        case 'AndroidAOSP':
            return false // can not accurately detect
        case 'AndroidChrome':
            return parseFloat(version) >= 42 ? /; wv/.test(ua)
            : /\d{2}\.0\.0/.test(version) ? true // 40.0.0, 37.0.0, 36.0.0, 33.0.0, 30.0.0
                : _isWebView_Android()
    }
    return false
}

function _isWebView_iOS () { // @arg Object - { WEB_VIEW }
    // @ret Boolean
    // Chrome 15++, Safari 5.1++, IE11, Edge, Firefox10++
    // Android 5.0 ChromeWebView 30: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 33: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 36: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 37: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 40: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 42: webkitFullscreenEnabled === ?
    // Android 5.0 ChromeWebView 44: webkitFullscreenEnabled === true
    const document = window.document
    return !('fullscreenEnabled' in document || 'webkitFullscreenEnabled' in document || false)
}

function _isWebView_Android () { // @arg Object - { WEB_VIEW }
    // Chrome 8++
    // Android 5.0 ChromeWebView 30: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 33: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 36: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 37: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 40: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 42: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 44: webkitRequestFileSystem === false
    return !('requestFileSystem' in window || 'webkitRequestFileSystem' in window || false)
}

class Screen {
    constructor () {
        let ua                  = window.navigator.userAgent
        let os                  = _detectOS(ua)
        let browser             = _detectBrowser(ua)
        let browserVersion      = _detectBrowserVersion(ua, browser)
        this.insetTop           = null
        this.insetBottom        = null
        this.h                  = window.screen.availHeight
        this.w                  = window.screen.availWidth
        this._insetsInitialized = false
        this._IS_BROWSER_AOSP   = browser === 'AOSP'
        this._IS_BROWSER_SAFARI = browser === 'Safari'
        this._IS_IOS            = os === 'iOS'
        this._IS_ANDROID        = os === 'Android'
        this._IS_WINDOWS        = os === 'Windows Mobile'
        this._MOBILE            = this._IS_IOS || this._IS_ANDROID || this._IS_WINDOWS
        this._WEB_VIEW          = _isWebView(ua, os, browser, browserVersion)
        if (this._IS_IOS) {
            this._IOS_VERSION = '' + _detectIOSVersion(ua)
        }
    }
    checkIsAndroid () {
        return this._IS_ANDROID
    }
    checkIsBrowserSafari () {
        return this._IS_BROWSER_SAFARI
    }
    checkIOS () {
        return this._IS_IOS
    }
    checkIsAOSP () {
        return this._IS_BROWSER_AOSP
    }
    checkIsDesktopIFrame () {
        return !this.checkMobile() && this.checkIsIFrame()
    }
    getIOSVersion () {
        return this._IOS_VERSION
    }
    checkIsIFrame () {
        return window.self !== window.top
    }
    checkMobile () {
        return this._MOBILE
    }
    checkWebView () {
        return this._WEB_VIEW
    }
    isSmallWidth () {
        return this.w < 400
    }
    inputSupported () {
        return !this._IS_IOS || this._IS_IOS && !this._WEB_VIEW || this._IS_IOS && +this._IOS_VERSION >= 11
    }
    isFullVK () {
        return document.referrer && document.referrer.includes('://vk.com')
    }
    initInsets () {
        if (this._insetsInitialized) {
            return
        }
        if (CSS.supports('padding-top: constant(safe-area-inset-top)')) {
            const div = document.createElement('div')
            div.style.paddingTop = 'constant(safe-area-inset-top)'
            div.style.paddingBottom = 'constant(safe-area-inset-bottom)'
            document.body.appendChild(div)
            this.insetTop = parseInt(window.getComputedStyle(div).paddingTop, 10)
            this.insetBottom = parseInt(window.getComputedStyle(div).paddingBottom, 10)
            this.div = 1
        } else if (CSS.supports('padding-top: env(safe-area-inset-top)')) {
            const div = document.createElement('div')
            div.style.paddingTop = 'env(safe-area-inset-top)'
            div.style.paddingBottom = 'env(safe-area-inset-bottom)'
            document.body.appendChild(div)
            this.insetTop = parseInt(window.getComputedStyle(div).paddingTop, 10)
            this.insetBottom = parseInt(window.getComputedStyle(div).paddingBottom, 10)
            this.div = 2
        }
        this._insetsInitialized = true
    }

}

export default new Screen
